/**
 * Tracks persistence operations started by Zustand persist.
 * It does not own a repository or introduce a second write path.
 */
export class WorkspaceCommitCoordinator {
  private readonly pending = new Set<Promise<unknown>>()
  private tail: Promise<void> = Promise.resolve()
  private discardCount = 0

  enqueue<T>(operation: () => Promise<T>): Promise<T> {
    const queued = this.tail.then(operation)
    this.tail = queued.then(() => undefined, () => undefined)
    return this.track(queued)
  }

  track<T>(operation: Promise<T>): Promise<T> {
    this.pending.add(operation)
    void operation.then(
      () => this.pending.delete(operation),
      () => this.pending.delete(operation),
    )
    return operation
  }

  async whenIdle(): Promise<void> {
    while (this.pending.size > 0) {
      await Promise.all([...this.pending])
    }
  }

  discardNextWrite(): void {
    this.discardCount += 1
  }

  consumeDiscardedWrite(): boolean {
    if (this.discardCount === 0) return false
    this.discardCount -= 1
    return true
  }
}
